import { Box, Grid, TextField, Typography } from "@material-ui/core";
import {
  Button,
  FilledInput,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextareaAutosize,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import React, { useMemo, useReducer, useState } from "react";
import { hostname } from "src/HostName";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  staticStop,
  TripType,
  PAX,
  SpecialOneWay,
  specialCabin,
} from "src/utils/stop";
import moment from "moment";
import CustomSnackbar from "../CustomComponents/CustomSnackbar";
import { useSnackbar } from "notistack5";
import InfoOutlineIcon from "@mui/icons-material/Info";
const EditAirportMarkup = (props) => {
  const {
    airportMarkup,
    data,
    providerIndex,
    handleAirlineClose,
    filterApiprovider,
    gateWayList,
    supplierId,
    fetchData,
  } = props;
  const { enqueueSnackbar } = useSnackbar();
  const LoginData = localStorage.getItem("LoginData");
  const user = JSON.parse(LoginData);

  const airportMarkupArray = airportMarkup.airportMarkup;
  const [addMarkupinAirport, setAddMarkupinAirport] = useState({
    userid: user.userid,
    AirCode: "",
    Amount: "",
    From: "",
    RuleDateFrom: "",
    RuleDateTo: "",
    To: "",
    capAmount: 0,
    originCountry: "",
    destinationCountry: "",
    minAmount: 0,
    maxAmount: 500000,
    stops: -1,
    tripType: "",
    noOfPAX: 1,
    cabinSegment: "",
    ruleName: "",
    cappingDays: 2,
    cabinSegmentInbound: "",
    arrTimeMarkup: 0,
    depTimeMarkup: 0,
    cabinClass: "Y",
    markupType: "FLAT",
    opaqueData: "",
    FareType: "",
    RuleDateToIn: "",
    RuleDateFromIn: "",
    flightNo: "",
    flightNoReturn: "",
    dGap: 0,
    dGapEnd: 0,
    operatedBy: "",
    gateway: "",
    status: true,
    ruleExpiry: "",
    specialOW: false,
    specialCabinClass: "",
    nonRefundable: false,
    discountDescription: "",
    mixRound: false,
    additionalPax: "",
    amountType: 0,
    ruleCategory: 0,
    baggageInfo: "",
  });
  const [showToast, setShowToast] = useState(false);
  const [filter, setFilter] = useState({});
  const [showToast2, setToast2] = useState(false);
  const handleFareObjChange = (e) => {
    const { value, name } = e.target;
    if (
      name === "capAmount" ||
      name === "minAmount" ||
      name === "maxAmount" ||
      name === "noOfPAX" ||
      name === "cappingDays" ||
      name === "arrTimeMarkup" ||
      name === "depTimeMarkup" ||
      name === "dGap" ||
      name === "dGapEnd"
    ) {
      setAddMarkupinAirport({ ...addMarkupinAirport, [name]: Number(value) });
    } else {
      setAddMarkupinAirport({ ...addMarkupinAirport, [name]: value });
    }
  };
  const totalDaysDep = useMemo(() => {
    const splitDate = addMarkupinAirport?.RuleDateFrom?.split("-");
    const date1 = moment(splitDate[0], "DD/MM/YYYY");
    const date2 = moment(splitDate[1], "DD/MM/YYYY");
    return date2.diff(date1, "days");
  }, [addMarkupinAirport?.RuleDateFrom]);
  const submit = () => {
    if (
      addMarkupinAirport.ruleName.length < 3 ||
      Number.isNaN(totalDaysDep) ||
      totalDaysDep < 0 ||
      addMarkupinAirport.AirCode < 2 ||
      (addMarkupinAirport.markupType === "%" &&
        -+addMarkupinAirport.Amount > 70)
    ) {
      let errMsg =
        addMarkupinAirport.ruleName.length < 3
          ? "Rule name should be minimum 3 characters long"
          : Number.isNaN(totalDaysDep) || totalDaysDep < 0
          ? "Please enter a valid OutBound date range"
          : addMarkupinAirport.markupType === "%" &&
            -+addMarkupinAirport.Amount > 70
          ? "Markup should be less than 70%"
          : "Airline code should be minimum 2 characters long";
      return enqueueSnackbar(errMsg, { variant: "error" });
    }
    const findAirportMarkup = airportMarkup.airportMarkup.find(
      (item) =>
        item.tripType === addMarkupinAirport.tripType &&
        item.noOfPAX === addMarkupinAirport.noOfPAX &&
        item.From === addMarkupinAirport.From &&
        item.To === addMarkupinAirport.To &&
        item.AirCode === addMarkupinAirport.AirCode &&
        item.ruleName === addMarkupinAirport.ruleName,
    );
    if (findAirportMarkup) {
      setShowToast(true);
      setFilter(findAirportMarkup);
      return;
    } else {
      const newAddAirportMarkup = [...airportMarkupArray, addMarkupinAirport];
      const newResAirportMar = {
        ...airportMarkup,
        airportMarkup: newAddAirportMarkup,
      };
      const Apiprovider = [...filterApiprovider, newResAirportMar];
      const Data = {
        _id: data._id,
        provider: Apiprovider,
        blockedAirportSource: data.blockedAirportSource,
        rule: data.rule,
        amount: data.amount,
        fromDate: data.fromDate,
        toDate: data.toDate,
        blockedCountrySource: data.blockedCountrySource,
        tripTypeSource: data.tripTypeSource,
        noOfPAXSource: data.noOfPAXSource,
        isactive: data.isactive,
        convFee: Number(data.convFee),
        loginUser: user?.userid,
        typeValue: addMarkupinAirport,
        type: "addrule",
        userid: supplierId,
      };

      const options = {
        method: "PATCH",
        url: `${hostname}update/farerule/info`,
        headers: { "Content-Type": "application/json" },
        data: Data,
      };
      axios
        .request(options)
        .then(function (response) {
          alert("Fare Rule Add Successfully!");
          handleAirlineClose();
          fetchData();
        })
        .catch(function (error) {
          console.error("error");
        });
    }
  };
  const handleSnackbar = () => {
    setShowToast(false);
    setToast2(false);
  };

  const AddAirportMarkup = () => {
    airportMarkupArray.push(addMarkupinAirport);
    const abc = [];
    for (let index = 0; index < data.apiprovider.length; index++) {
      const element = data.apiprovider[index];
      if (index === providerIndex) {
        const { airportMarkup, ...rest } = element;
        const abcD = { ...rest, airportMarkup: airportMarkupArray };
        abc.push(abcD);
      }
    }
    const Apiprovider = filterApiprovider.concat(abc);
    if (abc.length !== 0) {
      const Data = {
        _id: data._id,
        provider: Apiprovider,
        blockedAirportSource: data.blockedAirportSource,
        rule: data.rule,
        amount: data.amount,
        fromDate: data.fromDate,
        toDate: data.toDate,
        blockedCountrySource: data.blockedCountrySource,
        tripTypeSource: data.tripTypeSource,
        noOfPAXSource: data.noOfPAXSource,
        isactive: data.isactive,
        convFee: Number(data.convFee),
        loginUser: user?.userid,
      };
      const options = {
        method: "PATCH",
        url: `${hostname}update/farerule/info`,
        headers: { "Content-Type": "application/json" },
        data: Data,
      };
      axios
        .request(options)
        .then(function (response) {
          alert("Fare Rule Add Successfully");
          handleAirlineClose();
          handleSnackbar();
        })
        .catch(function (error) {
          console.error("error");
        });
    }
  };

  const buttonStyle = {
    marginBottom: "20px",
    marginTop: 2,
    height: "45px",
    fontSize: "16px",
    width: "140px",
  };
  return (
    <div>
      <TextField
        type="text"
        value={addMarkupinAirport.ruleName}
        name="ruleName"
        id="ruleName"
        onChange={(e) => {
          handleFareObjChange(e);
        }}
        label="Rule Name*"
        variant="filled"
        sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
      />
      <Box>
        <FormControl
          variant="filled"
          className="mb-4 me-2"
          style={{ width: "14.1875rem" }}
        >
          <InputLabel id="ruleCategory">Rule Category</InputLabel>
          <Select
            labelId="ruleCategory"
            id="ruleCategory"
            name="ruleCategory"
            value={addMarkupinAirport.ruleCategory}
            onChange={(e) => handleFareObjChange(e)}
          >
            {ruleCategory.map((item) => (
              <MenuItem value={item.value}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          variant="filled"
          className="mb-4 me-2"
          style={{ width: "14.1875rem" }}
        >
          <InputLabel id="tripType">Select TripType</InputLabel>
          <Select
            labelId="tripType"
            id="tripType"
            name="tripType"
            value={addMarkupinAirport.tripType}
            onChange={(e) => handleFareObjChange(e)}
          >
            {TripType.map((item) => (
              <MenuItem value={item.value}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          variant="filled"
          className="mb-4"
          style={{ width: "14.1875rem" }}
        >
          <InputLabel id="specialOW">Special OneWay</InputLabel>
          <Select
            labelId="specialOW"
            id="specialOW"
            name="specialOW"
            value={addMarkupinAirport.specialOW}
            onChange={(e) => handleFareObjChange(e)}
          >
            {SpecialOneWay.map((item) => (
              <MenuItem value={item.value}>{item.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {addMarkupinAirport?.specialOW && (
          <FormControl
            variant="filled"
            className="mb-4 me-4"
            style={{ width: "15.1875rem" }}
          >
            <InputLabel id="specialOW">Special CabinClass</InputLabel>
            <Select
              labelId="specialOW"
              id="specialOW"
              name="specialCabinClass"
              value={addMarkupinAirport.specialCabinClass}
              onChange={(e) => handleFareObjChange(e)}
            >
              {specialCabin.map((item) => (
                <MenuItem value={item.value}>{item.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
      </Box>
      <Box>
        <Grid
          container
          spacing={2}
          className="align-items-center flex-nowrap justify-content-center"
        >
          <Grid item xs={12} xl={3} md={3}>
            <FormControl variant="filled" className="mb-4 " fullWidth>
              <InputLabel id="noOfPAX">Select No of PAX</InputLabel>
              <Select
                labelId="noOfPAX"
                id="noOfPAX"
                name="noOfPAX"
                value={addMarkupinAirport.noOfPAX}
                onChange={(e) => handleFareObjChange(e)}
              >
                {PAX.map((item) => (
                  <MenuItem value={item.value}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <FormControl variant="filled" className="mb-4 me-4" fullWidth>
              <InputLabel htmlFor="filled-adornment-password">
                Additional Pax
              </InputLabel>
              <FilledInput
                name="additionalPax"
                id="filled-adornment-password"
                type={"text"}
                onChange={(e) => handleFareObjChange(e)}
                value={addMarkupinAirport?.additionalPax}
                endAdornment={
                  <Tooltip
                    slotProps={{
                      tooltip: {
                        className: "mytooltipImageWrapper",
                      },
                    }}
                    title={
                      <img
                        src="/static/components/paxType.png"
                        alt="preview"
                        objectFit="cover"
                      />
                    }
                  >
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <InfoOutlineIcon />
                      </IconButton>
                    </InputAdornment>
                  </Tooltip>
                }
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={3} md={3}>
            <FormControl variant="filled" className="mb-4 me-4" fullWidth>
              <InputLabel id="mixRound">Mix Round</InputLabel>
              <Select
                labelId="mixRound"
                id="mixRound"
                name="mixRound"
                value={addMarkupinAirport.mixRound}
                onChange={(e) => handleFareObjChange(e)}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid
          container
          spacing={2}
          className="align-items-center flex-nowrap justify-content-center"
        >
          <Grid item xs={12} xl={6} md={12}>
            <TextField
              name="From"
              id="From"
              type="text"
              // placeholder="Origin"
              value={addMarkupinAirport.From}
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              disabled={addMarkupinAirport.originCountry === "" ? false : true}
              label="Origin Airport"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Typography className="pl-3">OR</Typography>
          <Grid item xs={12} xl={6} md={12}>
            <TextField
              name="originCountry"
              id="originCountry"
              type="text"
              // placeholder="Origin Country"
              value={addMarkupinAirport.originCountry}
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              disabled={addMarkupinAirport.From === "" ? false : true}
              label="Origin Country"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid
          container
          spacing={2}
          className="align-items-center flex-nowrap justify-content-center"
        >
          <Grid item xs={12} xl={6} md={12}>
            <TextField
              name="To"
              id="To"
              type="text"
              // placeholder="Destination"
              value={addMarkupinAirport.To}
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              label="Destination Airport"
              variant="filled"
              disabled={
                addMarkupinAirport.destinationCountry === "" ? false : true
              }
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Typography className="pl-3">OR</Typography>
          <Grid item xs={12} xl={6} md={12}>
            <TextField
              name="destinationCountry"
              id="destinationCountry"
              type="text"
              // placeholder="DestinationCountry"
              value={addMarkupinAirport.destinationCountry}
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              disabled={addMarkupinAirport.To === "" ? false : true}
              label="Destination Country"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box className="d-flex">
        <Grid
          container
          spacing={2}
          className="align-items-center flex-nowrap justify-content-center"
        >
          <Grid item xs={12} xl={5} md={12} className="d-flex">
            <div className="d-flex align-items-center pb-3">
              <label className="mr-3" style={{ fontSize: "13px" }}>
                Markup Type
              </label>
              <div className="d-flex justify-content-center align-items-center">
                <div className="mr-4">
                  <input
                    name="markupType"
                    type="radio"
                    value={"%"}
                    checked={addMarkupinAirport.markupType === "%"}
                    id="markupType"
                    onChange={(e) => handleFareObjChange(e)}
                    className="mr-2 cursor-pointer"
                  />
                  <label>%</label>
                </div>
                <div>
                  <input
                    name="markupType"
                    type="radio"
                    checked={addMarkupinAirport.markupType === "FLAT"}
                    value={"FLAT"}
                    id="markupType"
                    placeholder="Fare Type"
                    onChange={(e) => handleFareObjChange(e)}
                    className="mr-2 cursor-pointer"
                  />
                  <label style={{ fontSize: "13px" }}>FLAT</label>
                </div>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} xl={3} md={12}>
            <TextField
              name="Amount"
              id="Amount"
              type="text"
              // placeholder="Amount"
              value={addMarkupinAirport.Amount}
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              label="Amount"
              disabled={addMarkupinAirport.capAmount !== 0 ? true : false}
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={4} md={12}>
            <FormControl variant="filled" className="mb-4 me-4" fullWidth>
              <InputLabel id="amountType">Amount Type</InputLabel>
              <Select
                labelId="amountType"
                id="amountType"
                name="amountType"
                value={addMarkupinAirport.amountType}
                onChange={(e) => handleFareObjChange(e)}
              >
                <MenuItem value={0}>Total</MenuItem>
                <MenuItem value={1}>Base Fare</MenuItem>
                <MenuItem value={2}>Tax</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>
      <Box className="d-flex">
        <Grid
          container
          spacing={2}
          className="align-items-center flex-nowrap justify-content-center"
        >
          <Grid item xs={12} xl={6} md={12}>
            <TextField
              name="capAmount"
              id="capAmount"
              type="text"
              placeholder="CapAmount"
              value={addMarkupinAirport.capAmount}
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              disabled={addMarkupinAirport.Amount === "" ? false : true}
              label="CapAmount"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={12}>
            <TextField
              name="cappingDays"
              id="cappingDays"
              type="text"
              value={addMarkupinAirport.cappingDays}
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="Capping Days"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="minAmount"
              value={addMarkupinAirport.minAmount}
              id="minAmount"
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="MinAmount"
              variant="filled"
              InputLabelProps={{ shrink: true }}
              disabled={addMarkupinAirport.capAmount !== 0 ? true : false}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="maxAmount"
              id="maxAmount"
              type="text"
              value={addMarkupinAirport.maxAmount}
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="MaxAmount"
              variant="filled"
              disabled={addMarkupinAirport.capAmount !== 0 ? true : false}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="cabinSegment"
              value={addMarkupinAirport.cabinSegment}
              id="cabinSegment"
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="Cabin Segment (V,E,L)"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="cabinSegmentInbound"
              id="cabinSegmentInbound"
              value={addMarkupinAirport.cabinSegmentInbound}
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="Cabin Segment Inbound"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="arrTimeMarkup"
              value={addMarkupinAirport.arrTimeMarkup}
              id="arrTimeMarkup"
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="ArrTime Markup"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="depTimeMarkup"
              id="depTimeMarkup"
              value={addMarkupinAirport.depTimeMarkup}
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="DepTime Markup"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            {/* <Grid item xs={12} xl={6} md={6}> */}
            <TextField
              name="RuleDateFrom"
              value={addMarkupinAirport.RuleDateFrom}
              id="RuleDateFrom"
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              placeholder="DD/MM/YYYY-DD/MM/YYYY"
              label="OutBound Start-End "
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
            {/* </Grid> */}
            {/* <Grid container spacing={2}>
              <Grid item xs={12} xl={6} md={6}>
                <TextField
                  name="RuleDateTo"
                  id="RuleDateTo"
                  value={addMarkupinAirport.RuleDateTo}
                  type="text"
                  onChange={(e) => handleFareObjChange(e)}
                  sx={{
                    marginBottom: "24px",
                    width: "100%",
                    borderRadius: "0",
                  }}
                  placeholder="MM/DD/YYYY"
                  label="Travel End"
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid> 
            </Grid> */}
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            {/* <Grid container spacing={2}>
              <Grid item xs={12} xl={6} md={6}> */}
            <TextField
              name="RuleDateFromIn"
              value={addMarkupinAirport.RuleDateFromIn}
              id="RuleDateFromIn"
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{
                marginBottom: "24px",
                width: "100%",
                borderRadius: "0",
              }}
              label="InBound Start-End"
              placeholder="DD/MM/YYYY-DD/MM/YYYY"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
            {/* </Grid> */}
            {/* <Grid item xs={12} xl={6} md={6}>
                <TextField
                  name="RuleDateToIn"
                  id="RuleDateToIn"
                  value={addMarkupinAirport.RuleDateToIn}
                  type="date"
                  onChange={(e) => handleFareObjChange(e)}
                  sx={{
                    marginBottom: "24px",
                    width: "100%",
                    borderRadius: "0",
                  }}
                  label="RuleDateToIn"
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid> */}
            {/* </Grid> */}
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} xl={6} md={6}>
                <TextField
                  name="AirCode"
                  value={addMarkupinAirport.AirCode}
                  id="AirCode"
                  type="Text"
                  onChange={(e) => handleFareObjChange(e)}
                  sx={{
                    marginBottom: "24px",
                    width: "100%",
                    borderRadius: "0",
                  }}
                  label="Airline Code"
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>

              <Grid item xs={12} xl={6} md={6}>
                <TextField
                  name="flightNo"
                  value={addMarkupinAirport.flightNo}
                  id="flightNo"
                  type="Text"
                  onChange={(e) => handleFareObjChange(e)}
                  sx={{
                    marginBottom: "24px",
                    width: "100%",
                    borderRadius: "0",
                  }}
                  label="flightNumber"
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12} xl={6} md={6}>
                <TextField
                  name="flightNoReturn"
                  value={addMarkupinAirport.flightNoReturn}
                  id="flightNoReturn"
                  type="Text"
                  onChange={(e) => handleFareObjChange(e)}
                  sx={{
                    marginBottom: "24px",
                    width: "100%",
                    borderRadius: "0",
                  }}
                  label="flightNoReturn"
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={12} xl={6} md={6}>
                <TextField
                  name="opaqueData"
                  id="opaqueData"
                  value={addMarkupinAirport.opaqueData}
                  type="text"
                  onChange={(e) => handleFareObjChange(e)}
                  sx={{
                    marginBottom: "24px",
                    width: "100%",
                    borderRadius: "0",
                  }}
                  label="Opaque Data"
                  variant="filled"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <FormControl
              variant="filled"
              className="mb-4 me-4"
              style={{ width: "15.1875rem" }}
            >
              <InputLabel id="stops">Select Stop</InputLabel>
              <Select
                labelId="stops"
                id="stops"
                name="stops"
                value={addMarkupinAirport.stops}
                onChange={(e) => handleFareObjChange(e)}
              >
                {staticStop.map((item) => (
                  <MenuItem value={item.value}>{item.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="cabinClass"
              id="cabinClass"
              value={addMarkupinAirport.cabinClass}
              type="text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="CabinClass"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box>
      {/* <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="RuleDateFromIn"
              value={addMarkupinAirport.RuleDateFromIn}
              id="RuleDateFromIn"
              type="date"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="RuleDateFromIn"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="RuleDateToIn"
              id="RuleDateToIn"
              value={addMarkupinAirport.RuleDateToIn}
              type="date"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="RuleDateToIn"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Box> */}
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="FareType"
              value={addMarkupinAirport.FareType}
              id="FareType"
              type="Text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="FareType"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="dGap"
              value={addMarkupinAirport.dGap}
              id="dGap"
              type="Text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="DaysGap"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="dGapEnd"
              value={addMarkupinAirport.dGapEnd}
              id="dGapEnd"
              type="Text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="DaysGap End"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <TextField
              name="operatedBy"
              value={addMarkupinAirport.operatedBy}
              id="operatedBy"
              type="Text"
              onChange={(e) => handleFareObjChange(e)}
              sx={{ marginBottom: "24px", width: "100%", borderRadius: "0" }}
              label="Pure Operated"
              variant="filled"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <FormControl
              variant="filled"
              className="mb-4 me-4"
              style={{ width: "15.1875rem" }}
            >
              <InputLabel id="gateway">Payment Gateway</InputLabel>
              <Select
                labelId="gateway"
                id="gateway"
                name="gateway"
                value={addMarkupinAirport.gateway}
                onChange={(e) => handleFareObjChange(e)}
              >
                <MenuItem value="">Select</MenuItem>
                {gateWayList.map((item) => (
                  <MenuItem value={item.gateway}>{item.gateway}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={6} md={6} className="">
            <TextField
              type="date"
              name="ruleExpiry"
              value={addMarkupinAirport.ruleExpiry}
              id="outlined-basic"
              label="Expiry Date"
              variant="filled"
              InputLabelProps={{ shrink: true }}
              fullWidth
              onChange={(e) => handleFareObjChange(e)}
            />
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <FormControl
              variant="filled"
              className="mb-4 me-4"
              style={{ width: "15.1875rem" }}
              error
            >
              <InputLabel id="nonRefundable">Non Refundable Flag</InputLabel>
              <Select
                labelId="nonRefundable"
                id="nonRefundable"
                name="nonRefundable"
                value={addMarkupinAirport.nonRefundable}
                onChange={(e) => handleFareObjChange(e)}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
              {addMarkupinAirport.nonRefundable && (
                <FormHelperText>
                  Selecting ‘YES’ will display a ‘NON-REFUNDABLE’ flag on the
                  website.
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={6} md={6}>
            <FormControl
              variant="filled"
              className="mb-4 me-4"
              style={{ width: "15.1875rem" }}
            >
              <InputLabel id="status">Status</InputLabel>
              <Select
                labelId="status"
                id="status"
                name="status"
                value={addMarkupinAirport.status}
                onChange={(e) => handleFareObjChange(e)}
              >
                <MenuItem value={true}>Active</MenuItem>
                <MenuItem value={false}>Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} xl={12} md={12}>
            <TextareaAutosize
              minRows={2}
              placeholder="Write Baggage Information..."
              name="baggageInfo"
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                padding: "12px",
                resize: "none",
                background: "#f7f7f7",
                borderRadius: "8px",
              }}
              onChange={(e) => handleFareObjChange(e)}
              value={addMarkupinAirport?.baggageInfo}
            />
          </Grid>
          <Grid item xs={12} xl={12} md={12}>
            <TextareaAutosize
              minRows={2}
              placeholder="Write Discount Description..."
              name="discountDescription"
              style={{
                width: "100%",
                border: "none",
                outline: "none",
                padding: "12px",
                resize: "none",
                background: "#f7f7f7",
                borderRadius: "8px",
              }}
              onChange={(e) => handleFareObjChange(e)}
              value={addMarkupinAirport?.discountDescription}
            />
          </Grid>
        </Grid>
      </Box>
      <CustomSnackbar
        open={showToast || showToast2}
        onClose={handleSnackbar}
        title={
          showToast2
            ? `You are about to apply a discount greater than -5% for ${totalDaysDep} days. Please confirm to continue.`
            : `${filter.ruleName} is already exist, Please ensure to add this rule`
        }
        handleConfirm={() => {
          showToast2 && submit();
          showToast && AddAirportMarkup();
        }}
      />
      <div className="text-center">
        <Button
          variant="contained"
          onClick={() => {
            if (
              totalDaysDep > 0 &&
              +addMarkupinAirport.Amount < -5 &&
              +addMarkupinAirport.Amount < 0 &&
              addMarkupinAirport.markupType === "%"
            ) {
              setToast2(true);
            } else {
              submit();
            }
          }}
          sx={buttonStyle}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default EditAirportMarkup;

export const ruleCategory = [
  { name: "NONE", value: 0 },
  { name: "GOLD", value: 1 },
  { name: "SILVER", value: 2 },
  { name: "PLATINUM", value: 3 },
  { name: "BRONZE", value: 4 },
];
